import {
  VIGO_QUOTATION_ALL,
  VIGO_QUOTATION_CONFIRMED,
  VIGO_QUOTATION_CREATED,
  VIGO_QUOTATION_EXPIRED,
  VIGO_QUOTATION_REJECTED,
} from 'utils/vigoQuotation'

const VIGO_QUOTATION_STATUES_VI = {
  [VIGO_QUOTATION_ALL]: 'TẤT CẢ',
  [VIGO_QUOTATION_CREATED]: 'MỚI',
  [VIGO_QUOTATION_CONFIRMED]: 'ĐÃ XÁC NHẬN',
  [VIGO_QUOTATION_EXPIRED]: 'HẾT HẠN',
  [VIGO_QUOTATION_REJECTED]: 'TỪ CHỐI',
}
export const VIGO_QUOTATION_VI = {
  vigoQuotationNumber: 'Mã báo giá Vigo',
  detail: 'Chi tiết báo giá',
  statusHistory: 'Lịch sử thay đổi',
  no: 'Thứ tự',
  createdDate: 'Ngày tạo',
  updatedDate: 'Ngày cập nhật',
  updateBy: 'Người cập nhật',
  relatedDocuments: 'Thông tin liên quan',
  deliveryTo: 'Vận chuyển đến',
  quotationDetails: 'Chi tiết báo giá',
  shipment: 'Tuyến hàng',
  vigoQuotation: 'Báo giá từ Vigo',
  deliveredBy: 'Giao hàng bởi',
  noOfItem: 'Số lượng',
  totalAmount: 'Tổng giá trị',
  image: 'Hình ảnh',
  name: 'Tên sản phẩm',
  selectWarehouse: 'Chọn kho hàng',
  actualOfferPrice: 'Giá đề nghị thực tế',
  vigoOfferPrice: 'Giá đề nghị từ Vigo',
  requestedQuantity: 'Số lượng yêu cầu',
  actualTotalAmount: 'Tổng giá trị thực tế',
  totalPriceDifferent: 'Tổng giá chênh lệch',
  packType: 'Đơn vị đóng gói',
  estimatedWeight: 'Trọng lượng ước tính (kg)',
  confirm: 'Xác nhận',
  warehouse: 'Kho hàng',
  distributor: 'Nhà phân phối',
  creationTime: 'Thời gian tạo',
  startDate: 'Ngày bắt đầu',
  endDate: 'Ngày kết thúc',
  search: 'Tìm kiếm',
  reset: 'Cài lại',
  refresh: 'Làm mới',
  currentStatus: 'Trạng thái hiện tại',
  requestDate: 'Ngày yêu cầu',
  confirmDeadline: 'Thời gian xác nhận',
  totalValue: 'Tổng giá trị',
  status: 'Trạng thái',
  pre: 'Trang trước',
  next: 'Trang kế tiếp',
  nationalDrugCode: 'Mã dược quốc gia',
  batchNumber: 'Số lô',
  shelfLifeMonth: 'Thời gian sử dụng theo tháng',
  manufacturingDate: 'Ngày sản xuất',
  expirationDate: 'Hạn sử dụng',
  quantity: 'Số lượng',
  productSku: 'Tên sản phẩm - SKU',
  discountPercent: 'Chiết khấu',
  beforeDiscount: 'Trước chiết khấu',
  actualPrice: 'Giá thực tế',
  vatPrice: 'Giá sau thuế',
  distributor_pickup: 'Nhà phân phối giao',
  referenceSellingPriceBeforeDiscount: 'Giá bán tham khảo cho NPP',
  priceVigoAgreesToSellToDistributorBeforeDiscount:
    'Giá Vigo đồng ý bán cho NPP ',
  totalAmountReferenceSellingPriceForDistributor:
    'Tổng Giá bán tham khảo cho NPP',
  totalAmountPriceVigoAgreesToSellToDistributor:
    'Tổng Giá Vigo đồng ý bán cho NPP',
  totalAmountVigoPurchasePriceSurveyFinal: 'Tổng giá nhập Vigo khảo sát final',
  totalAmountPurchasePriceVigoAcceptToBuy:
    'Tổng giá vốn Vigo chấp nhận mua hàng',
  ...VIGO_QUOTATION_STATUES_VI,
}
